import General from './general'
import Countries from './countries'
import Graphics from './graphics'

export default {
  ...General,
  ...Countries,
  ...Graphics
}
